import script from "./InvoiceLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvoiceLayout.vue?vue&type=script&setup=true&lang=ts"

import "./InvoiceLayout.vue?vue&type=style&index=0&id=60d65712&scoped=true&lang=stylus"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d65712"]])

export default __exports__